import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { MyDiaryQuestionProps } from "../../../interfaces/props/SaudeBemEstar/MeuDiario/MyDiaryQuestionProps";
import './styles.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { } from "@fortawesome/free-solid-svg-icons";
import { MeuDiarioTipoQuestEnum } from "../../../interfaces/enum/MeuDiarioTipoQuestEnum";
import { sxLabel, sxQuestionTextField, sxRadioGroup } from "./sxProps";
import { faCheck, faFaceLaughBeam, faFrown, faMeh, faSadTear, faSmile } from "@fortawesome/pro-regular-svg-icons";
import { faFaceMeh, faFaceSadTear, faFaceSmile, faFrownOpen, faLaughBeam } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useId, useState } from "react";

function MyDiaryQuestion(props: MyDiaryQuestionProps) {
  const [radio, setRadio] = useState<string>('');
  const [textfield, setTexfield] = useState<string>('');
  const accessibility = useAccessibility();

  const id = useId();

  useEffect(() => {
    if (props.disabled) {
      setRadio(props.question.resposta);
      setTexfield(props.question.resposta);
    }
  }, [])

  const handleRadio = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    setRadio(event.target.value);
    props.handleAnswer(event.target.value, props.index, index);
  }

  const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    if (event.target.checked) {
      props.handleAnswer('S', props.index, index);
    }
    else {
      props.handleAnswer('N', props.index, index);
    }
  }

  const handleText = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTexfield(event.target.value)
    props.handleAnswer(event.target.value, props.index, -1);
  }

  const getIcon = (icon: string) => {
    switch (icon) {
      case "far fa-sad-tear":
        return faSadTear;
      case "far fa-frown":
        return faFrown;
      case "far fa-meh":
        return faMeh;
      case "far fa-smile":
        return faSmile;
      case "far fa-laugh-beam":
        return faFaceLaughBeam;
      case "fas fa-check":
        return faCheck;
      default:
        return faSadTear;
    }
  }

  const getCheckedIcon = (icon: string) => {
    switch (icon) {
      case "far fa-sad-tear":
        return faFaceSadTear;
      case "far fa-frown":
        return faFrownOpen;
      case "far fa-meh":
        return faFaceMeh;
      case "far fa-smile":
        return faFaceSmile;
      case "far fa-laugh-beam":
        return faLaughBeam;
      case "fas fa-check":
        return faCheck;
      default:
        return faSadTear;
    }
  }

  return (
    <div className="my-diary-question-holder">
      <h2 className="my-diary-question-title" style={accessibility.textStyleAccessibility}>{props.question.txtQuestao}</h2>
      <label htmlFor={id} aria-label={props.question.txtQuestao} />
      <span className="my-diary-question-text" style={accessibility.textStyleAccessibility}>{props.question.txtCompl}</span>
      <div className="my-diary-question-answers">
        {props.question.codTipoQuestaoTeleOrient === MeuDiarioTipoQuestEnum.radio &&
          <FormControl fullWidth>
            <RadioGroup
              row
              aria-label={props.question.txtQuestao}
              name="position"
              value={radio}
              sx={sxRadioGroup}
            >
              {props.question.lstQuestoesTriagem.map((item, index) => {
                return (
                  <FormControlLabel
                    value={item.vlrItem}
                    control={
                      <Radio
                        disabled={props.disabled}
                        onChange={e => handleRadio(e, index)}
                        icon={
                          <FontAwesomeIcon icon={getIcon(item.icon)} style={accessibility.contrastColorAccessibility} size="2x" className="icon" />
                        }
                        checkedIcon={
                          <FontAwesomeIcon icon={getCheckedIcon(item.icon)} style={accessibility.contrastColorAccessibility} size="2x" className="radio-checked-icon" />
                        }
                      />}
                    label={item.txtItemQuestao}
                    labelPlacement="bottom"
                    sx={sxLabel}
                  />
                )
              })}
            </RadioGroup>
          </FormControl>
        }
        {props.question.codTipoQuestaoTeleOrient === MeuDiarioTipoQuestEnum.text &&
          <div className="question-textfield">
            <TextField
              disabled={props.disabled}
              id={id}
              onChange={handleText}
              value={textfield}
              sx={sxQuestionTextField}
              multiline
              rows={4}
              defaultValue="Default Value"
              fullWidth
            />
          </div>
        }
        {props.question.codTipoQuestaoTeleOrient === MeuDiarioTipoQuestEnum.checkbox &&
          <fieldset role="group" aria-labelledby={id + "-question-group"} className="checkbox-fieldset">
          <legend id={id + "-question-group"}>{props.question.txtQuestao}</legend>
          <div className="question-options">
            {props.question.lstQuestoesTriagem.map((item, index) => {
              if (!props.disabled) {
                return (
                  <FormControlLabel
                    value={item.idItemQuestaoTeleOrient}
                    control={
                      <Checkbox
                        onChange={(e) => handleCheckbox(e, index)}
                        icon={
                          <FontAwesomeIcon icon={getIcon(item.icon)} style={accessibility.contrastColorAccessibility} size="2x" className="icon" />
                        }
                        checkedIcon={
                          <div className={`${accessibility.contrastMode ? 'contrast-checked-icon' : 'checked-icon'}`}>
                            <FontAwesomeIcon icon={getIcon(item.icon)} />
                          </div>
                        } />
                    }
                    label={item.txtItemQuestao}
                    labelPlacement="bottom"
                  />
                )
              }
              else {
                return (
                  <FormControlLabel
                    value={item.idItemQuestaoTeleOrient}
                    control={
                      <Checkbox
                        disabled={props.disabled}
                        checked={item.vlrItem === 'S'}
                        onChange={(e) => handleCheckbox(e, index)}
                        icon={
                          <FontAwesomeIcon icon={getIcon(item.icon)} style={accessibility.contrastColorAccessibility} size="2x" className="icon" />
                        }
                        checkedIcon={
                          <div className={`${accessibility.contrastMode ? 'contrast-checked-icon' : 'checked-icon'}`}>
                            <FontAwesomeIcon icon={getIcon(item.icon)} />
                          </div>
                        } />
                    }
                    label={item.txtItemQuestao}
                    labelPlacement="bottom"
                  />
                )
              }
            })}
          </div>
          </fieldset>
        }
      </div>
    </div>
  )
}

export default MyDiaryQuestion;